export default __webpack_public_path__ + "4400fc2cc74a9a56f7c6343a3ed3fc80.webp";